import { useEffect, useState } from 'react';

/**
 * A brand's logo at list size. Without one, or when it fails to load, the
 * brand's initial on its colour stands in, so a column of names stays aligned.
 */
export function BrandLogoThumb({ src, name, accent }: { src: string | undefined; name: string; accent: string }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [src]);
  const initial = (name.trim().charAt(0) || '?').toUpperCase();
  return (
    <span
      style={{
        display: 'inline-grid', placeItems: 'center', flex: 'none', width: '1.75rem', height: '1.75rem',
        borderRadius: '6px', overflow: 'hidden', border: '1px solid var(--line-strong)',
        fontSize: '0.8125rem', fontWeight: 650,
        ...(src && !failed ? { background: '#fff' } : { background: accent, color: '#fff' }),
      }}
    >
      {src && !failed ? (
        <img src={src} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} onError={() => setFailed(true)} />
      ) : (
        <span aria-hidden="true">{initial}</span>
      )}
    </span>
  );
}
